import Flatpickr from "stimulus-flatpickr";

// Picker defaults for every field; a field's data-flatpickr-* attributes still win
export default class extends Flatpickr {
  initialize() {
    this.config = {
      locale: { firstDayOfWeek: 1 },
      time_24hr: true,
    };
  }
}
